import { Collapse, List, ListItemButton, ListItemText } from '@mui/material'
import { Box } from '@mui/system'
import { useState } from 'react'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { ReactComponent as SwitchIcon } from '../../../../images/ChangeIcon.svg'
import IconWithName from './iconWithName'
import CookiesStorageService from '../../../../services/CookiesStorageService'
import UseTranslation from '../../../../hooks/UseTranslation'

const SwitchModulesBtn = () => {
  const [open, setOpen] = useState(false)
  const { t } = UseTranslation()
  const handleClick = () => {
    setOpen(!open)
  }

  const redirectToSelectedModuleHandler = (moduleCode) => {
    const moduleUrls = {
      eds: process.env.REACT_APP_EDS_FRONTEND_URL,
      recruitment: process.env.REACT_APP_RECRUITMENT_FRONTEND_URL,
      self: process.env.REACT_APP_SELF_FRONTEND_URL,
      core: `${process.env.REACT_APP_CORE_FRONTEND_URL}/`,
      admin: '/',
    };

    return moduleUrls[moduleCode] || '';
  }

  return (
    <Box sx={styles.root}>
      <Box sx={styles.expandBtn} onClick={handleClick}>
        <IconWithName name={t?.['Switching Module']} icon={<SwitchIcon />} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </Box>

      <Collapse in={open} timeout='auto' unmountOnExit>
        <List component='div' disablePadding
        sx={{
          '&:last-child': {
            borderBottom: '0px solid #ededed',
          },
        }}
        >
          {CookiesStorageService.getUserModules()?.map((singleModule, i) => (

            <a
              href={redirectToSelectedModuleHandler(singleModule?.code)}
              style={styles.link}
              key={singleModule.name}
            >
              <ListItemButton sx={[styles.singleModuleBtn,
                singleModule.name === 'Admin' && styles.activeModelColor,
                i === (CookiesStorageService.getUserModules().length - 1) && styles.lastItem,
              ]}
              >
                <ListItemText primary={singleModule.name} />
              </ListItemButton>
            </a>
          ))}
        </List>
      </Collapse>
    </Box>
  )
}

const styles = {
  root: {},
  expandBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& svg': {
      fill: '#92929D',
      fontSize: { xs: '14px', sm: '18px' },
    },
  },
  singleModuleBtn: {
    marginLeft: '20px',
    borderBottom: '1px solid #ededed',
    '& .MuiTypography-root': {
      fontSize: { xs: '10px', sm: '16px' },
    },
    span: {
      lineHeight: { xs: '15px !important', sm: '25px !important' },
    },
  },
  activeModelColor: { color: '#29CC8B' },
  link: {
    display: 'block',
    textDecoration: 'none',
    color: 'inherit',
    height: { xs: '20px', sm: '40px' },
  },
  lastItem: { borderBottom: '0px !important', marginBottom: '-15px' },
}
export default SwitchModulesBtn
